import script from "./InfoPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoPopup.vue?vue&type=script&setup=true&lang=ts"

import "./InfoPopup.vue?vue&type=style&index=0&id=0ba066bf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ba066bf"]])

export default __exports__